
import React from 'react';
import {IonContent, IonIcon, IonPage} from "@ionic/react";
import {callOutline, locationOutline, mailOutline} from "ionicons/icons";

export default function ContactUsPage({renderHeaderPage}) {
    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="common-content contact-us-page page-content">
                <div className="desktop-contain-aboutus">
                    <h1 className="m-0 p-heading text-left">Contact Info</h1>
                    <div className={"contact_us_grid vision-section"}>
                        <div className={"contact_us_grid_row"}>
                            <div className="contact-box contact_us_grid_col text-left">
                                <h3 className="contact-title">
                                    <IonIcon icon={locationOutline} className="contact-icon"/>
                                    <div>Address</div> </h3>
                                <p className="contact-detail text-left">
                                    909, Chiranjiv Tower<br/>
                                    43, Nehru Place<br/>
                                    New Delhi - 110019
                                </p>
                                <div className={"border-bottom"}></div>
                                <h3 className="contact-title">
                                    <IonIcon icon={callOutline} className="contact-icon"/> <div>Phone No: </div></h3>
                                <p className="contact-detail">
                                    +91-9873230416<br/>
                                    +91-11-26223712<br/>
                                </p>
                                <div className={"border-bottom"}></div>
                                <h3 className="contact-title">
                                    <IonIcon icon={mailOutline} className="mail-icon"/> <div>Email ID: </div>
                                </h3>
                                <p className="contact-detail">
                                    <a href="mailto:aicas.cfo@gmail.com" className="contact-email">
                                        aicas.cfo@gmail.com
                                    </a>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
)
}